import React from "react";
import AutomationList from "../shared/components/AutomationList";
import { WORKFLOW_CATEGORY } from "../workflow/utils/enums";

const AttendanceAutomation: React.FC = () => {
  return (
    <AutomationList
      workflowCategory={WORKFLOW_CATEGORY.ATTENDANCE}
      title="Attendance Automation"
      breadcrumb="Attendance"
      module="attendance"
    />
  );
};

export default AttendanceAutomation;
